import React from 'react';
import ReactDom from 'react-dom';
import {Provider} from 'react-redux';
import store from './app/store';
import reportWebVitals from './reportWebVitals';
import RouterApp from "./App";
import {ThemeProvider} from "@deere/fuel-react";
import './index.css';

ReactDom.render(
    <React.StrictMode>
        <Provider store={store}>
           <RouterApp/>
            {/* <RouterApp/> */}
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
